"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const js_client_sdk_common_1 = require("@eppo/js-client-sdk-common");
/** An {@link BulkWriteAssignmentCache} assignment cache backed by an in-memory {@link Map} */
class SimpleAssignmentCache {
    constructor() {
        this.store = new Map();
        this.cache = new js_client_sdk_common_1.NonExpiringInMemoryAssignmentCache(this.store);
    }
    set(key) {
        this.cache.set(key);
    }
    has(key) {
        return this.cache.has(key);
    }
    setEntries(entries) {
        const { store } = this;
        // it's important to call store.set() directly here because we want to set the raw entries into the cache, bypassing
        // the AbstractAssignmentCache logic, which takes an AssignmentCacheKey instead.
        entries.forEach(([key, value]) => store.set(key, value));
    }
    getEntries() {
        return Promise.resolve(Array.from(this.cache.entries()));
    }
}
exports.default = SimpleAssignmentCache;
//# sourceMappingURL=simple-assignment-cache.js.map